import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearStore, setAccessToken, setRefreshToken, setStoreDetails } from "../../app/slice/authSlice";
import jwt_decode from "jwt-decode";
import { logoutUser } from "../../app/slice/thunk/authActions";
const CHANNEL_NAME = "auth-channel";

const useAuthSync = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const channelRef = useRef(null);

  useEffect(() => {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channelRef.current = channel;

    channel.onmessage = ({ data }) => {
      const { action, token } = data;

      if (action === "login") {
        console.log("[Auth Sync] Login event received from another tab");
        if (token) {
        //   dispatch(setAccessToken(token));
           const userInfo = jwt_decode(data.token.access);
              userInfo.role = userInfo?.role?.toLowerCase();
              dispatch(setRefreshToken(data.token.refresh));
              dispatch( setAccessToken(data.token.access) );
              dispatch( setStoreDetails(userInfo) );
        }
        navigate("/admin/dashboard");
      }

      if (action === "logout") {
        console.log("[Auth Sync] Logout event received from another tab");
        dispatch(logoutUser());
        localStorage.clear();
        navigate("/auth/login");
      }
    };

    return () => {
      channel.close();
    };
  }, [dispatch, navigate]);

  const login = (token) => {
    if (!token) return;
    const userInfo = jwt_decode(token.access);
    userInfo.role = userInfo?.role?.toLowerCase();
    dispatch(setRefreshToken(token.refresh));
    dispatch( setAccessToken(token.access) );
    dispatch( setStoreDetails(userInfo) );
    channelRef.current?.postMessage({ action: "login", token });
    console.log('login fn ')
    navigate("/admin/dashboard");
  };

  const logout = () => {
    console.log('logout fn ')
    channelRef.current?.postMessage({ action: "logout" });
    dispatch(logoutUser());
    localStorage.clear();
    navigate("/auth/login");
  };

  return { login, logout };
};

export default useAuthSync;
